import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { SecretsPage } from '@/features/access/secrets/secrets-page';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/secrets/')({ component: SecretsRoute });

function SecretsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="secrets" crumbs={[{ label: t('access.secrets.title') }]}>
      <SecretsPage tenantId={tenant} />
    </ConsoleShell>
  );
}
